module.exports = __webpack_public_path__ + "img/P8_popup_thumb_5_en.8ef12811.png";